import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

export interface ItemContainerProps extends PropsWithChildren {
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingTop: 15,
            paddingBottom: 15,
            borderTop: '1px solid #D4D4D4'
        }
    })
);

export const ItemContainer: FunctionComponent<ItemContainerProps> = props => {
    const classes = useStyles(props);

    return <Box className={clsx(classes.container, props.className)}>{props.children}</Box>;
};

export default ItemContainer;
